import IconEye from '@/assets/svg/ic_eye.svg';
import IconHeart from '@/assets/svg/ic_heart.svg';
import iconHeartFilled from '@/assets/svg/ic_heart-filled.svg';
import IconDownload from '@/assets/svg/ic_download.svg';
import iconMoveFolder2 from '@/assets/svg/ic_move_folder2.svg';
import iconCopy from '@/assets/svg/ic_copy.svg';
import iconCrop from '@/assets/svg/ic_crop.svg';
import iconEditFile from '@/assets/svg/ic_edit-file.svg';
import iconTrash from '@/assets/svg/ic_trash.svg';
import iconPaste from '@/assets/svg/ic_clipboard.svg';
import { DirectoryFolderType } from '@/components/ImageLibrary/constants/directoryElement.js';

export const FILE_LIB_MAX_FILE_UPLOAD = 10;
export const FILE_LIB_STORE_ITEMS_KEY = 'fileLibraryItems';
export const FILE_LIB_STORE_FAVORITE_ITEMS_KEY = 'image-library-favorites';
export const FILE_LIB_STORE_SIDEBAR_ITEMS_KEY = 'sidebarLibItems';
export const FILE_LIB_STORE_DEST_ITEMS_KEY = 'file-lib-copy-mode-dest';
export const FILE_LIB_STORE_PATH_TO_ITEM_KEY = 'file-lib-path-to-item';

export const FileLibraryItemType = {
    PROJECT: 'project',
    COURSE: 'course',
    FOLDER: 'folder',
    FILE: 'file',
};

export const FILELIB_TYPE_TO_DIR_TYPE_MAP = {
    [FileLibraryItemType.PROJECT]: DirectoryFolderType.PROJECT,
    [FileLibraryItemType.COURSE]: DirectoryFolderType.VERSION,
    [FileLibraryItemType.FOLDER]: DirectoryFolderType.FOLDER,
};

export const FileLibItemMenuActionsTypes = {
    PREVIEW: 'preview',
    FAVORITE: 'favorite',
    REMOVE_FAVORITE: 'removeFavorite',
    MOVE: 'move',
    COPY: 'copy',
    CROP: 'crop',
    DOWNLOAD: 'download',
    RENAME: 'rename',
    DELETE: 'delete',
    SHOW_IN_FOLDER: 'showInFolder',
    PASTE: 'paste',
};

export const FileLibItemMenuActions = {
    PREVIEW: {
        type: 'item',
        text: 'Предпросмотр',
        iconInline: IconEye,
        handler: FileLibItemMenuActionsTypes.PREVIEW,
    },
    FAVORITE: {
        type: 'item',
        text: 'В избранное',
        iconInline: IconHeart,
        handler: FileLibItemMenuActionsTypes.FAVORITE,
    },
    REMOVE_FAVORITE: {
        type: 'item',
        text: 'Удалить из избранного',
        iconInline: iconHeartFilled,
        handler: FileLibItemMenuActionsTypes.REMOVE_FAVORITE,
    },
    MOVE: {
        type: 'item',
        text: 'Переместить',
        iconInline: iconMoveFolder2,
        handler: FileLibItemMenuActionsTypes.MOVE,
    },
    COPY: {
        type: 'item',
        text: 'Копировать',
        iconInline: iconCopy,
        handler: FileLibItemMenuActionsTypes.COPY,
    },
    CROP: {
        type: 'item',
        text: 'Обрезать',
        iconInline: iconCrop,
        handler: FileLibItemMenuActionsTypes.CROP,
    },
    DOWNLOAD: {
        type: 'item',
        text: 'Скачать',
        iconInline: IconDownload,
        handler: FileLibItemMenuActionsTypes.DOWNLOAD,
    },
    RENAME: {
        type: 'item',
        text: 'Переименовать',
        iconInline: iconEditFile,
        handler: FileLibItemMenuActionsTypes.RENAME,
    },
    DELETE: {
        type: 'item',
        text: 'Удалить',
        iconInline: iconTrash,
        handler: FileLibItemMenuActionsTypes.DELETE,
    },
    PASTE: {
        type: 'item',
        text: 'Вставить',
        iconInline: iconPaste,
        handler: FileLibItemMenuActionsTypes.PASTE,
    },
};

const getFavoriteItemAction = item => (item.in_favorites ? FileLibItemMenuActions.REMOVE_FAVORITE : FileLibItemMenuActions.FAVORITE);

const getPasteItemAction = (item, options) => ({
    ...FileLibItemMenuActions.PASTE,
    disabled: options?.paste?.disabled ?? true,
    disabledTooltipData: {
        content: options?.paste?.tooltip ?? 'Создайте и скопируйте изображение с помощью ИИ-ассистента',
        position: 'left',
        tooltipClass: 'text-left',
        maxWidth: 215,
    },
});

export const FILE_MENU_ACTIONS = [
    FileLibItemMenuActions.PREVIEW,
    getFavoriteItemAction,
    FileLibItemMenuActions.MOVE,
    FileLibItemMenuActions.COPY,
    FileLibItemMenuActions.CROP,
    FileLibItemMenuActions.DOWNLOAD,
    FileLibItemMenuActions.RENAME,
    FileLibItemMenuActions.DELETE,
];

export const FAVORITE_FILE_MENU_ACTIONS = [
    FileLibItemMenuActions.PREVIEW,
    getFavoriteItemAction,
    FileLibItemMenuActions.CROP,
    FileLibItemMenuActions.DOWNLOAD,
    FileLibItemMenuActions.RENAME,
    FileLibItemMenuActions.DELETE,
];

export const PROJECT_MENU_ACTIONS = [
    getFavoriteItemAction,
    FileLibItemMenuActions.DOWNLOAD,
];

export const COURSE_MENU_ACTIONS = [
    getFavoriteItemAction,
    getPasteItemAction,
    FileLibItemMenuActions.DOWNLOAD,
];

export const FOLDER_MENU_ACTIONS = [
    getFavoriteItemAction,
    FileLibItemMenuActions.MOVE,
    FileLibItemMenuActions.COPY,
    FileLibItemMenuActions.DOWNLOAD,
    FileLibItemMenuActions.RENAME,
    getPasteItemAction,
    FileLibItemMenuActions.DELETE,
];

export const FAVORITE_FOLDER_MENU_ACTIONS = [
    getFavoriteItemAction,
    FileLibItemMenuActions.DOWNLOAD,
    FileLibItemMenuActions.RENAME,
    getPasteItemAction,
    FileLibItemMenuActions.DELETE,
];
